module.exports = __webpack_public_path__ + "static/img/badge.2794652.svg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/badge.svg
// module id = 61+i
// module chunks = 1